import { styled } from '@mui/system'
import { Dialog, FormControl, FormHelperText } from '@mui/material'

export const UserDialogDialog = styled(Dialog)(() => ({
  '& .MuiDialogTitle-root, & .MuiDialogActions-root': {
    padding: '0.8rem 2.3rem',
  },
  '& .MuiDialogContent-root': {
    overflowY: 'unset',
    padding: '0 1.rem',
  },
  '& .MuiPaper-root': {
    padding: '0.6rem 0rem',
  },
  '& .MuiInputBase-root': {
    marginRight: '0.8rem',
  },
}))

export const UserDialogFormControl = styled(FormControl)(() => ({
  margin: 5,
  width: '100%',
}))

export const UserDialogFormHelperText = styled(FormHelperText)(({ theme }) => ({
  color: theme.palette.error.main,
}))
